import { State } from '../../types';

export const newYork: State = {
  name: 'New York',
  abbreviation: 'NY',
  terms: [
    {
      word: 'Binghamton',
      phonetic: 'BING-um-ton',
      // audioUrl: '/audio/binghamton.mp3',
      description: 'City in southern New York'
    },
    {
      word: "Bodega",
      phonetic: "bo-DAY-guh",
      description: "A small convenience store, often run by Hispanic families, central to NYC neighborhoods.",
    },
    {
      word: 'Canandaigua',
      phonetic: 'kan-uh-DAY-gwuh',
      // audioUrl: '/audio/canandaigua.mp3',
      description: 'City in the Finger Lakes region'
    },
    {
      word: 'Canarsie',
      phonetic: 'kuh-NAR-see',
      description: 'A neighborhood in Brooklyn, originally named after the Canarsee Native Americans.'
    },
    {
      word: 'Chautauqua',
      phonetic: 'sha-TAW-kwa',
      // audioUrl: '/audio/chautauqua.mp3',
      description: 'A town, county, and lake in Western New York, with a name of Native American origin.'
    },
    {
      word: 'Coxsackie',
      phonetic: 'cook-SAH-kee',
      // audioUrl: '/audio/coxsackie.mp3',
      description: 'A town in Greene County, often mispronounced due to its unique spelling. The name is derived from an Algonquin word meaning "place of owls."'
    },
    {
      word: 'Fteley Avenue',
      phonetic: 'fuh-tel-lee',
      // audioUrl: '/audio/fteley_avenue.mp3',
      description: 'A street in New York with a tricky pronunciation.'
    },
    {
      word: 'Gansevoort Street',
      phonetic: 'gan-suh-vort',
      // audioUrl: '/audio/gansevoort_street.mp3',
      description: 'A street often mispronounced by visitors.'
    },
    {
      word: 'Gowanus',
      phonetic: 'guh-WAH-nus',
      description: 'A Brooklyn canal and neighborhood with roots in the Lenape language.'
    },
    {
      word: 'Houston Street',
      phonetic: 'house-ton',
      // audioUrl: '/audio/houston_street.mp3',
      description: 'Named after William Houston, pronounced differently than the Texas city.'
    },
    {
      word: 'Joralemon Street',
      phonetic: 'jor-ah-le-mon',
      // audioUrl: '/audio/joralemon_street.mp3',
      description: 'Named after Tumis Joralemon, the first to own a brick house in Brooklyn.'
    },
    {
      word: 'Kaatskill',
      phonetic: 'KATS-skill',
      description: 'An older spelling of the Catskill Mountains, rooted in Dutch heritage.'
    },
    {
      word: "Knish",
      phonetic: "kuh-NISH",
      description: "A traditional Jewish pastry filled with potatoes or meat, sold in delis.",
    },
    {
      word: 'Kosciuszko Street',
      phonetic: 'ka-zee-oo-skow',
      // audioUrl: '/audio/kosciuszko_street.mp3',
      description: 'Americanized pronunciation; Polish speakers say "ko-shoos-ko."'
    },
    {
      word: 'Maujer Street',
      phonetic: 'moy-jer',
      // audioUrl: '/audio/maujer_street.mp3',
      description: 'Brooklyn street renamed in 1937 to honor Daniel Maujer.'
    },
    {
      word: 'New Utrecht Avenue',
      phonetic: 'you-trek',
      // audioUrl: '/audio/new_utrecht_avenue.mp3',
      description: 'Named after the colony established in 1652.'
    },
    {
      word: 'Oneonta',
      phonetic: 'oh-nee-ON-tuh',
      // audioUrl: '/audio/oneonta.mp3',
      description: 'A city in Otsego County, often mispronounced due to its unique combination of vowels.'
    },
    {
      word: 'Poughkeepsie',
      phonetic: 'puh-KIP-see',
      // audioUrl: '/audio/poughkeepsie.mp3',
      description: 'A city in Dutchess County, with a name derived from a Wappinger word meaning "the reed-covered lodge by the little water place."'
    },
    {
      word: 'Schenectady',
      phonetic: 'skuh-NEK-tuh-dee',
      // audioUrl: '/audio/schenectady.mp3',
      description: 'City in eastern New York'
    },
    {
      word: 'Schermerhorn Street',
      phonetic: 'skir-mir-horn',
      // audioUrl: '/audio/schermerhorn_street.mp3',
      description: 'Brooklyn street named after the Schermerhorn family.'
    },
    {
      word: "Schlep",
      phonetic: "shlep",
      description: "A Yiddish word meaning to carry or drag something, reflecting the city’s Jewish influence.",
    },
    {
      word: 'Spuyten Duyvil',
      phonetic: 'SPITE-en DIVE-ul',
      description: 'A neighborhood in the Bronx, its name means "spouting devil" in Dutch.'
    },
    {
      word: 'Taughannock',
      phonetic: 'tuh-GAN-ick',
      // audioUrl: '/audio/taughannock.mp3',
      description: 'Home to one of the most beautiful waterfalls and parks in New York State.'
    },
    {
      word: 'Wappinger',
      phonetic: 'WAH-pin-jer',
      // audioUrl: '/audio/wappinger.mp3',
      description: 'A town in Dutchess County, named after the Wappinger tribe.'
    }
  ]
};